<template>
  <el-collapse-transition>
    <div v-if="msg" class="zt-tip" :class="typeClass">

      <slot name="prepend">
        <svg-icon v-if="typeClass == 'success'" icon="success"/>
        <svg-icon v-if="typeClass == 'error'" icon="wrong"/>
        <svg-icon v-if="typeClass == 'wrong'" icon="wrong"/>
        <svg-icon v-if="typeClass == 'warn'" icon="warn"/>
      </slot>

      <slot name="msg">{{msg}}</slot>

      <span class="append">
        <slot name="append"></slot>
      </span>

    </div>
  </el-collapse-transition>
</template>

<script>
export default {
  props: {
    'msg': String,
    'type': {
      type: String,
      defalut: 'success',
    },
  },
  computed: {
    'typeClass'() {
      return this.type ? this.type : 'success'
    },
  },
}
</script>

<style lang="scss" scoped>
.zt-tip {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  line-height: 20px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  /deep/ .svg-icon {
    width: 24px;
    height: 24px;
    min-width: 24px;
    min-height: 24px;
    margin-right: 6px !important;
  }
  &.success {
    color: $theme-green;
    background-color: mix(#fff,$theme-green-tint,50%);
  }
  &.error {
    color: $theme-orange;
    background-color: mix(#fff,$theme-orange-tint,50%);
  }
  &.wrong {
    color: $theme-orange;
    background-color: mix(#fff,$theme-orange-tint,50%);
  }
  &.warn {
    color: $theme-purple;
    background-color: mix(#fff,$theme-purple-tint,50%);
  }
  .append {
    flex: 1;
    text-align: right;
    white-space: nowrap;
    margin-left: 6px;
  }
}
</style>